import graphql__5411fdd008d9db5c7a9f from "./__generated__/ContactDataOriginList_contact.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import {useFragment} from "react-relay/hooks";
import { FormattedDate } from "react-intl";

type Props = {
    queryRef: any
}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});


type ContactDataOriginListProps = Props & ConnectedProps<typeof connector>;


const ContactDataOriginList: React.FC<ContactDataOriginListProps> = (props) => {
    const contact = useFragment(
        graphql__5411fdd008d9db5c7a9f
        , props.queryRef
    )


    return (
        <>
            <ul className="space-y-6">
                {contact.dataOrigins.map((dataOriginItem, dataOriginItemIdx) => (
                    <li key={dataOriginItem.id} className="flex gap-x-4">
                        <p className="grow py-0.5 text-gray-500">
                            <span className="font-medium text-gray-900">{dataOriginItem.description}</span>
                            {dataOriginItem.note && <span className="text-gray-500"><br/>({dataOriginItem.note})</span>}
                        </p>
                        <span className="shrink-0 py-0.5  text-gray-500">
                            <FormattedDate value={dataOriginItem.collectedAt} day="2-digit" month="2-digit" year="numeric"/>
                        </span>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default connector(ContactDataOriginList);
